import ImagesFields from './ImagesFields';

export default ImagesFields;
